
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { Sinister } from '../../../shared/types/sinisters/sinisterInfo'
import Button from '../../../core/components/Generics/Button.vue'
import ItemIndicators from '../../item/components/ItemIndicators.vue'
import { formatDate } from '../../../core/utils/date-handlers';
import SatellitalEvolutionChart from '../../claim-blocks/satellital/SatellitalEvolutionChart.vue';
import SinisterMapLayers from '../../claim-blocks/SinisterMapLayers.vue';
import InspectionSection from '../../claim-blocks/inspection/InspectionSection.vue';
import SurfaceZonificationInfo from '../../claim-blocks/surface-zonificacion/SurfaceZonificationInfo.vue';
import { ItemInfo } from '../../../shared/types/itemInfo';
import { SatellitalLayersInfo } from '../../../shared/types/satellital/layers';
import { defaultUserPrivilege, PrivilegeValue } from '../../../shared/privileges/privileges';
import { InjectionKey } from '../../../core/injection-keys';
import { IndicatorConfig, TenantConfig } from '../../../tenants/types';
@Component({
    components: {
        ItemIndicators,
        SinisterMapLayers,
        InspectionSection,
        SurfaceZonificationInfo,
        SatellitalEvolutionChart,
        Button
    }
})

/**
 * Siniestros de un item en acordeón (el primero, el más reciente, abierto por defecto). Cada panel reutiliza los
 * bloques del detalle de siniestro: indicadores (`pages.claimDetail.indicators`), mapa con capas, superficie de
 * zonificación, inspección y gráfico climático/satelital.
 */
export default class ClaimsAccordion extends Vue {
    @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
    @Prop({ default: () => [] }) sinisters!: Sinister[];
    @Prop({ default: () => null }) itemPolygon: ItemInfo["polygon"];
    @Prop({ default: () => defaultUserPrivilege }) privilege!: PrivilegeValue;
    panel: number[] = [];

    get claimIndicators(): IndicatorConfig[] {
        return this.tenant.pages.claimDetail ? this.tenant.pages.claimDetail.indicators : [];
    }

    created() {
        if (this.sinisters.length > 0) {
            this.panel = [0];
        }
    }
    satellitalLayersInfo: SatellitalLayersInfo = {
        zonified: {
            date: null,
            png_url: null,
            total_area: null,
            bar_url: '',
            zones: [],
            bounds: null
        },
        ndvi: {
            initial_date: null,
            final_date: null,
            png_url: null,
            bar_url: '',
            total_area: null,
            zones: [],
            bounds: null
        }
    }

    pendingOps: { [k: string]: Array<(c:any)=>void> } = {};

    // Nota seleccionada / en hover por siniestro, compartida entre mapa y listado
    selectedNoteIds: { [sinisterId: number]: number | null } = {};
    hoveredNoteIds: { [sinisterId: number]: number | null } = {};

    selectNote(noteId: number | null, sinisterId: number) {
        this.$set(this.selectedNoteIds, sinisterId, noteId);
    }

    hoverNote(noteId: number | null, sinisterId: number) {
        this.$set(this.hoveredNoteIds, sinisterId, noteId);
    }

    key(refBase: string, id: number) {
        return `${refBase}-${id}`;
    }

    getRef(refBase: string, id: number) {
        const r = this.$refs[this.key(refBase, id)];
        return Array.isArray(r) ? r[0] : r || null;
    }

    onChildMounted(refBase: string, id: number) {
        const comp = this.getRef(refBase, id);
        const k = this.key(refBase, id);
        const q = this.pendingOps[k];
        if (comp && q && q.length) {
            q.forEach(run => run(comp));
            delete this.pendingOps[k];
        }
    }

    callChild(refBase: string, id: number, method: string, ...args: any[]) {
        const comp = this.getRef(refBase, id);
        if (comp && typeof comp[method] === 'function') {
            comp[method](...args);
            return;
        }
        // buffer hasta que el componente monte
        const k = this.key(refBase, id);
        (this.pendingOps[k] || (this.pendingOps[k] = []))
            .push((c) => c[method] && c[method](...args));
    }
    
    parseDate(value){
       return formatDate(value, false, true)
    }

    seeNotesInMap(notes, sinisterId) {
        this.callChild('map', sinisterId, 'seeNotesInMap', notes);
    }


    //Actualizo props en los componentes hijos (DE LA INSTANCIA ACTUAL)
    //Cuando detecto click en un punto del grafico, actualizo la imagen satelital seleccionada
    onClickedChartPoint(pointIndex: number, id: number) {
        this.callChild('map', id, 'clickedSatelliteImage', pointIndex);
    }

    //Cuando cambia la imagen seleccionada en SinisterMapLayers actualizo el indice en el grafico
    updateCarouselIndex(idx: number, id: number) {
        this.callChild('chart', id, 'updateCarouselIndex', idx);
    }

    updateSelectedImageInChart(img, id: number) {
        this.callChild('chart', id, 'updateSelectedImage', img);
    }

    //Cuando cambia la banda seleccionada en SinisterMapLayers actualizo la prop en el grafico
    updateSelectedBandInChart(band, id: number) {
        this.callChild('chart', id, 'updateSelectedBand', band);
    }

    //Actualizo la informacion de las capas en los componentes hijos de la misma instancia
    updateLayersInfoInChilds(newLayers, id: number) {
        this.callChild('surface', id, 'updateLayersInfoZonified', newLayers.zonified);
        this.callChild('surface', id, 'updateLayersInfoNdvi', newLayers.ndvi);
        this.callChild('chart', id, 'updateSatellitalLayersInfo', newLayers);
    }

    updateLoadingZonification(v: boolean, id: number) {
        this.callChild('surface', id, 'updateLoadingZonification', v);
    }

    updateLoadingNdviDiff(v: boolean, id: number) {
        this.callChild('surface', id, 'updateLoadingNdviDiff', v);
    }

    //Actualizo la prop 'loading' en informacion de zonificacion y grafico
    updateLoadingMapInChilds(v: boolean, id: number) {
        this.callChild('chart', id, 'updateIsLoadingLayers', v);
        this.updateLoadingZonification(v, id);
        this.updateLoadingNdviDiff(v, id);
    }

    addRgbNdviToChart(values, id: number) {
     this.callChild('chart', id, 'setRgbAndNdviValues', values);
    }


}

